import { PropsWithChildren, FC } from 'react';
import classNames from 'classnames';

import { useLoadingState } from '@hh.ru/magritte-common-use-loading-state';
import { SkeletonProps } from '@hh.ru/magritte-ui-skeleton/types';
import { useSkeletonAnimationSync } from '@hh.ru/magritte-ui-skeleton/useSkeletonAnimationSync';

import styles from './styles.less';

export const Skeleton: FC<PropsWithChildren<SkeletonProps>> = ({
    children,
    width,
    height,
    borderRadius,
    borderTopLeftRadius,
    borderTopRightRadius,
    borderBottomLeftRadius,
    borderBottomRightRadius,
    inline = false,
    additionalClass = '',
    loading = false,
}) => {
    const isLoading = useLoadingState() || loading;
    const ref = useSkeletonAnimationSync(isLoading);
    const isHalfHeight = [
        borderRadius,
        borderBottomLeftRadius,
        borderBottomRightRadius,
        borderTopLeftRadius,
        borderTopRightRadius,
    ].includes('halfHeight');

    if (isLoading) {
        return (
            <div
                ref={ref}
                className={classNames(styles.skeleton, additionalClass, { [styles.skeletonInline]: inline })}
                style={
                    additionalClass
                        ? {}
                        : Object.fromEntries(
                              Object.entries({
                                  width,
                                  height,
                                  ...(isHalfHeight
                                      ? { borderRadius: 'halfHeight' }
                                      : {
                                            borderRadius,
                                            borderTopLeftRadius,
                                            borderTopRightRadius,
                                            borderBottomLeftRadius,
                                            borderBottomRightRadius,
                                        }),
                              })
                                  .filter((entry) => entry[1] !== undefined)
                                  .map((radius) => (radius[1] === 'halfHeight' ? [radius[0], 99999] : radius))
                          )
                }
            />
        );
    }

    return <>{children}</>;
};
